// Citizens panel scenario key constant
export const CITIZENS_PANEL_KEY = "net_zero_futures_dvl_shift_high_transstshiftec_2001";

// Map UI scenario+variant -> backend key
export function scenarioKeyForBackend({ scenario, variant = "low" }) {
  // Handle special scenario
  if (scenario === CITIZENS_PANEL_KEY) {
    return CITIZENS_PANEL_KEY;
  }
  
  const MAP = {
    current:   { low: "net_zero_futures_dvl_current_low_0909",   high: "net_zero_futures_dvl_current_high_0909" },
    steer:     { low: "net_zero_futures_dvl_steer_low_0909",     high: "net_zero_futures_dvl_steer_high_0909" },
    shift:     { low: "net_zero_futures_dvl_shift_low_0909",     high: "net_zero_futures_dvl_shift_high_0909" },
    transform: { low: "net_zero_futures_dvl_transform_low_0909", high: "net_zero_futures_dvl_transform_high_0909" },
  };
  return MAP[scenario]?.[variant] ?? null;
}

// Derive UI scenario+variant from sectorImpact (your rule-set)
export function getCurrentScenarioInfo(sectorImpact) {
  const defs = {
    steer: {
      low:  { food: "current", buildings: "current", transport: "low",  industry: "low" },
      high: { food: "current", buildings: "low",     transport: "low",  industry: "low" },
    },
    shift: {
      low:  { food: "low",     buildings: "low",     transport: "high", industry: "low" },
      high: { food: "low",     buildings: "high",    transport: "low",  industry: "low" },
    },
    transform: {
      low:  { food: "low",     buildings: "high",    transport: "high", industry: "low" },
      high: { food: "high",    buildings: "high",    transport: "high", industry: "high" },
    },
    current: {
      low:  { food: "current", buildings: "current", transport: "current", industry: "current" },
      high: { food: "current", buildings: "current", transport: "current", industry: "current" },
    },
    net_zero_futures_dvl_shift_high_transstshiftec_2001: {
      panel: { food: "panel", buildings: "panel", transport: "panel", industry: "panel" },
    },
  };

  for (const [scenario, variants] of Object.entries(defs)) {
    for (const [variant, cfg] of Object.entries(variants)) {
      const match = Object.entries(cfg).every(([k, v]) => sectorImpact?.[k] === v);
      if (match) return { scenario, variant };
    }
  }
  return { scenario: "current", variant: "low" };
}

